module.exports = __webpack_public_path__ + "static/media/mail-selected.427ee128.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/mail-selected.svg
// module id = 782
// module chunks = 0